import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=5e9d17c1&"
import script from "./BaseInfo.vue?vue&type=script&lang=js&"
export * from "./BaseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports